import React, { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import CustomSelect from './CustomSelect';
import AlertModal from './AlertModal';

export default function DateRangeFilter({ onFilterChange }) {
  const [range, setRange] = useState("all");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const handlePresetChange = (val) => {
 setRange(val);

 const now = new Date();
 let start = null;
 let end = null;

 if (val === "this_month") {
 start = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
 end = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];
 } else if (val === "this_year") {
 start = new Date(now.getFullYear(), 0, 1).toISOString().split('T')[0];
 end = new Date(now.getFullYear(), 11, 31).toISOString().split('T')[0];
 } else if (val === "all") {
 start = null;
 end = null;
 }

 if (val !== "custom") {
 setCustomStart(start || "");
 setCustomEnd(end || "");
 onFilterChange(start, end);
 }
 };

  const applyCustomDates = () => {
    if (customStart && customEnd) {
      if (new Date(customStart) > new Date(customEnd)) {
        setIsAlertOpen(true);
        return;
      }
    }
    if (customStart || customEnd) {
      onFilterChange(customStart || null, customEnd || null);
    }
  };

 const options = [
 { value: "all", label: "Depuis l'origine" },
 { value: "this_month", label: "Ce mois-ci" },
 { value: "this_year", label: "Cette année" },
 { value: "custom", label: "Période personnalisée" }
 ];

 return (
 <div className="flex flex-col sm:flex-row sm:items-center gap-3 w-full">
 <div className="w-full md:w-56 relative">
 <CalendarDays 
 className="absolute left-3 top-1/2 z-10 h-4 w-4 -translate-y-1/2 pointer-events-none text-tertiary"
 aria-hidden="true"
 />
 <CustomSelect 
 value={range} 
 onChange={handlePresetChange}
 options={options}
 triggerClassName="!pl-10"
 />
 </div>

 {range === "custom" && (
 <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full">
 <input 
 type="date" 
 value={customStart} 
 onChange={(e) => setCustomStart(e.target.value)}
 className="workspace-input py-1 min-h-[2.5rem] w-full sm:w-auto"
 />
 <span className="text-tertiary text-sm hidden sm:inline">au</span>
 <input 
 type="date" 
 value={customEnd} 
 onChange={(e) => setCustomEnd(e.target.value)}
 className="workspace-input py-1 min-h-[2.5rem] w-full sm:w-auto"
 />
        <button 
          onClick={applyCustomDates}
          className="btn btn-secondary py-1 min-h-[2.5rem] w-full sm:w-auto"
        >
          Appliquer
        </button>
      </div>
      )}

      <AlertModal 
        isOpen={isAlertOpen}
        onClose={() => setIsAlertOpen(false)}
        onConfirm={() => setIsAlertOpen(false)}
        title="Dates incohérentes"
        description="La date de début ne peut pas être postérieure à la date de fin. Veuillez corriger les dates sélectionnées."
        confirmText="Compris"
        cancelText="Fermer"
      />
    </div>
  );
}
